var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel-tab__content"},[_c('el-form',{attrs:{"size":"mini","label-width":"96px"},nativeOn:{"submit":function($event){$event.preventDefault();}}},[_c(_vm.witchTaskComponent,_vm._b({tag:"component"},'component',_vm.$props,false))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }